// Minimal, functional-only Lifecycle stage dropdown (Module 7) — shared between
// ChatInfo.jsx and (later) ContactsList.jsx. No visual polish yet, deliberately —
// this exists to prove the already-built/tested backend (Modules 1-6) works
// end-to-end through a real UI. Real design pass is a separate later task.
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select, MenuItem, CircularProgress, Box } from "@mui/material";
import {
  fetchLifecycleStages,
  moveContactLifecycleStage,
} from "../../redux/Slice/Lifecycle/lifecycleStageSlice";

function LifecycleStageSelect({ contactId, currentStageId }) {
  const dispatch = useDispatch();
  const stages = useSelector((state) => state.lifecycleStage.stages);
  const [selected, setSelected] = useState(currentStageId || "");
  const [saving, setSaving] = useState(false);

  // Owner bypasses at the backend (roleMiddleware.js) — the stored Lifecycle.Edit
  // boolean defaults to false even for Owner, so check roleName too. Same gap/fix
  // as LifecycleSettings.jsx's Configure check.
  const roleName = useSelector((s) => s.userDetails?.userDetails?.roleName || null);
  const LifecyclePermissions = useSelector(
    (s) => s.userDetails?.userPermissions?.permissions?.Lifecycle || {}
  );
  const canEdit = roleName === "Owner" || LifecyclePermissions.Edit;

  useEffect(() => {
    dispatch(fetchLifecycleStages());
  }, [dispatch]);

  useEffect(() => {
    setSelected(currentStageId || "");
  }, [currentStageId, contactId]);

  const handleChange = async (e) => {
    const toStageId = e.target.value;
    if (!toStageId || !contactId) return;
    setSaving(true);
    try {
      await dispatch(moveContactLifecycleStage({ contactId, toStageId })).unwrap();
      setSelected(toStageId);
    } catch (err) {
      console.error("Failed to move Lifecycle stage:", err);
    } finally {
      setSaving(false);
    }
  };

  if (!stages.length) {
    return null;
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Select
        size="small"
        value={selected}
        onChange={handleChange}
        displayEmpty
        disabled={saving || !canEdit}
        sx={{ minWidth: 140 }}
      >
        <MenuItem value="">
          <em>No stage</em>
        </MenuItem>
        {stages.map((stage) => (
          <MenuItem key={stage._id} value={stage._id}>
            {stage.name}
            {stage.stageType === "lost" ? " (Lost)" : ""}
          </MenuItem>
        ))}
      </Select>
      {saving && <CircularProgress size={16} />}
    </Box>
  );
}

export default LifecycleStageSelect;
